// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2A7ow","colMin":"styles_colMin__1x4q4"};